import { render } from "./historylog-overview.vue?vue&type=template&id=3240b339"
import script from "./historylog-overview.vue?vue&type=script&lang=js"
export * from "./historylog-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__